var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 425,
    viewBox: "0 0 346 425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.033 145.494C331.575 147.402 288.174 171.866 288.174 226.266C288.174 289.187 343.4 311.447 345.053 311.998C344.798 313.355 336.279 342.484 315.935 372.164C297.795 398.282 278.85 424.358 250.029 424.358C221.209 424.358 213.792 407.61 180.521 407.61C148.097 407.61 136.569 424.91 110.207 424.91C83.8444 424.91 65.4501 400.742 44.3008 371.062C19.8033 336.209 0.0102539 282.064 0.0102539 230.675C0.0102539 148.25 53.5827 104.535 106.308 104.535C134.323 104.535 157.676 122.937 175.265 122.937C192.007 122.937 218.115 103.433 249.987 103.433C262.066 103.433 305.467 104.535 334.033 145.494ZM234.856 68.5376C248.037 52.892 257.362 31.1832 257.362 9.47443C257.362 6.46403 257.107 3.41123 256.556 0.952026C235.11 1.75763 209.596 15.2408 194.21 33.0912C182.131 46.8288 170.857 68.5376 170.857 90.5432C170.857 93.8504 171.408 97.1576 171.663 98.2176C173.019 98.472 175.223 98.7688 177.427 98.7688C196.669 98.7688 220.87 85.8792 234.856 68.5376Z",
    fill: "url(#paint0_linear_125_2365)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_125_2365",
    x1: -12.8047,
    y1: 0.952006,
    x2: 363.309,
    y2: 17.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9B45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldApple);
export default __webpack_public_path__ + "static/media/gold_apple.402989fabea84dc4567430c92e2928ad.svg";
export { ForwardRef as ReactComponent };